import { useQuery } from '@tanstack/react-query';

import { api } from './client';
import type { PlanDto, RouterDto, ServiceKind } from './types';

/** Listas que casi toda pantalla necesita para sus selectores. */

export function useRouters() {
  return useQuery({
    queryKey: ['routers'],
    queryFn: () => api.get<RouterDto[]>('/routers'),
    staleTime: 30_000,
  });
}

/**
 * Planes del router indicado. Los planes globales heredados sólo vienen con
 * `includeGlobal` (pantalla de Planes); los selectores de altas no los ofrecen.
 */
export function usePlans(
  routerId?: string,
  includeInactive = false,
  service?: ServiceKind,
  includeGlobal = false,
) {
  return useQuery({
    queryKey: ['plans', routerId ?? 'all', includeInactive, service ?? 'all', includeGlobal],
    queryFn: () =>
      api.get<PlanDto[]>('/plans', {
        routerId,
        includeInactive,
        service,
        includeGlobal: includeGlobal || undefined,
      }),
    staleTime: 30_000,
  });
}
